import { render, staticRenderFns } from "./mainform.vue?vue&type=template&id=0884ca0c&scoped=true&"
import script from "./mainform.vue?vue&type=script&lang=js&"
export * from "./mainform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0884ca0c",
  null
  
)

export default component.exports